import * as React from 'react'
import ReactDOM from 'react-dom'
import cn from 'clsx'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import { DialogFooterSlotContext } from './slot-context'
import styles from './index.module.css'

type Props = {
  primary?: React.ReactNode
  secondary?: React.ReactNode
  corner?: React.ReactNode
  onClose?: (...args: Array<any>) => any
  footerMargin?: number
}
export default function DialogFooter(props: Props): React.ReactNode {
  // When surrounding chrome offers a slot, render there instead of inline so
  // the footer sits outside the scrolling content. Defaults to inline.
  const slot = React.useContext(DialogFooterSlotContext)

  const footer = (
    <div
      className={cn('DialogFooter', styles.dialogFooterBottomRow)}
      data-footer-margin={props.footerMargin}
    >
      {props.secondary}
      <div className={styles.dialogFooterBottomCorner}>{props.corner}</div>
      {props.onClose ? (
        <ButtonContainer>
          <Button onClick={props.onClose} caption="Cancel" />
          {props.primary}
        </ButtonContainer>
      ) : (
        <span>{props.primary}</span>
      )}
    </div>
  )

  return slot ? ReactDOM.createPortal(footer, slot) : footer
}
